export function isBrowser() {
    return IS_BROWSER + '' === 'true';
}
